<template>

  <div>

    <div id="sharing" class="bg-image small"></div>

    <div class="bg-white">
      <div class="container py-3">
        <br class="d-none d-md-block">
        <h1 class="h2">How PNO trailer sharing works</h1>
        <p class="lead grey">Optimizing asset usage is at the heart of our business.</p>
        <hr class="d-none d-md-block">
        <br class="d-none d-md-block">
        <div class="row">
          <div class="col-md-6">
            <div class="card">
              <div class="card-header">PNO rental customers</div>
              <div class="card-body">
                <p>Existing PNO rental customers can put their long-term rental assets to work if periodically idle.</p>
                <ul class="list-unstyled">
                  <li><i class="far fa-check mr-1"></i> Lower your monthly cost</li>
                  <li><i class="far fa-check mr-1"></i> Flexible fleet management</li>
                  <li><i class="far fa-check mr-1"></i> A-Z handling and one point of contact</li>
                </ul>
                <a href="https://pnorental.com/contact/" class="btn btn-outline-success">Get in touch</a>
              </div>
            </div>
            <br class="d-md-none">
          </div>
          <div class="col-md-6">
            <div class="card">
              <div class="card-header">Individual trailer owners</div>
              <div class="card-body">
                <p>Commercial trailer owners can increase their revenue by renting out trailer when not in use.</p>
                <ul class="list-unstyled">
                  <li><i class="far fa-check mr-1"></i> Earn extra cash</li>
                  <li><i class="far fa-check mr-1"></i> Insurance included</li>
                  <li><i class="far fa-check mr-1"></i> Set rental price and availability</li>
                </ul>
                <a href="/owner" class="btn btn-outline-success">List your trailer</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

export default {
  mounted() {
      this.$store.commit('meta/title', 'How PNO trailer sharing works')
      this.$store.commit('meta/description', 'Optimizing asset usage is at the heart of our business.')
      this.$store.commit('meta/image', this.generateSmartImgUrl(require('@/assets/img/bg_pno_how.jpg') , 'ogimage'));
  },
}
</script>
